import { motion } from 'framer-motion';
import { XCircle, AlertTriangle } from 'lucide-react';

const painPoints = [
  {
    icon: XCircle,
    text: 'Sering pindah dari scalping ke swing tanpa arah yang jelas'
  },
  {
    icon: XCircle,
    text: 'Mengikuti mentor yang profil risikonya tidak sama'
  },
  {
    icon: XCircle,
    text: 'Belajar indikator, tapi tidak punya SOP eksekusi'
  },
  {
    icon: XCircle,
    text: 'Overtrade, revenge trade, lalu menyalahkan psikologi'
  },
  {
    icon: XCircle,
    text: 'Tidak pernah benar-benar tahu gaya trading yang cocok'
  }
];

const ProblemSection = () => {
  return (
    <section
      className="py-24 md:py-32 relative overflow-hidden"
      data-testid="problem-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-16"
        >
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-red-500/10 border border-red-500/20 mb-6">
            <AlertTriangle className="w-4 h-4 text-red-400" />
            <span className="text-sm text-red-400 font-medium">MASALAH UTAMA</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-white mb-6">
            Kenapa banyak trader merasa <span className="text-red-400">bingung</span>
          </h2>
        </motion.div>

        {/* Pain Points Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
          {painPoints.map((point, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: idx * 0.1 }}
              className="glass-card rounded-xl p-6 group"
            >
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-lg bg-red-500/10 flex items-center justify-center flex-shrink-0 group-hover:bg-red-500/20 transition-colors">
                  <point.icon className="w-5 h-5 text-red-400" />
                </div>
                <p className="text-tc-text-secondary leading-relaxed pt-2">
                  {point.text}
                </p>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Truth Bomb */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.5 }}
          className="text-center relative mt-12"
        >
          <div className="inline-block glass-card rounded-2xl px-10 py-8 border-tc-primary/30">
            <p className="text-xl md:text-2xl font-heading font-semibold text-white">
              Strategi yang bagus bisa <span className="text-red-400">gagal</span> jika dipakai oleh{' '}
              <span className="text-tc-primary">trader yang tidak cocok.</span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ProblemSection;
